module.exports = __webpack_public_path__ + "media/images/flags/ae-da8a9112ae87067d99626518f54ed108.svg";